import { useLocation, useNavigate } from 'react-router-dom';

// material-ui
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import ButtonBase from '@mui/material/ButtonBase';
import Tooltip from '@mui/material/Tooltip';

// project imports
import LogoSection from '../LogoSection';
import SearchSection from './SearchSection';
import ProfileSection from './ProfileSection';
import NotificationSection from './NotificationSection';

import { handlerDrawerOpen, useGetMenuMaster } from 'api/menu';
import useConfig from 'hooks/useConfig';

// assets
import { IconMenu2, IconSettings } from '@tabler/icons-react';

// ==============================|| MAIN NAVBAR / HEADER ||============================== //

export default function Header() {
  const theme = useTheme();
  const { state: { mode = 'light' } = {} } = useConfig();
  const downMD = useMediaQuery(theme.breakpoints.down('md'));
  const location = useLocation();
  const navigate = useNavigate();

  const { menuMaster } = useGetMenuMaster();
  const drawerOpen = menuMaster.isDashboardDrawerOpened;

  const isSettingsActive = location.pathname === '/account-settings';

  return (
    <>
      {/* logo & toggler button */}
      <Box sx={{ width: downMD ? 'auto' : 170, display: 'flex', alignItems: 'center' }}>
        <Box component="span" sx={{ display: { xs: 'none', md: 'flex' }, alignItems: 'center', flexGrow: 1, pr: 0.5 }}>
          <LogoSection />
        </Box>

        <Tooltip title="Toggle Navigation" arrow>
          <ButtonBase
            sx={{
              width: 38,
              height: 38,
              minWidth: 38,
              borderRadius: '8px',
              bgcolor: 'transparent',
              color: mode === 'dark' ? (theme.palette?.text?.secondary || '#A4ABB8') : '#475569',
              transition: 'all 0.2s ease-in-out',
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              '&:hover': {
                bgcolor: mode === 'dark' ? (theme.palette?.background?.hover || '#2A2E36') : '#F1F5F9',
                color: mode === 'dark' ? '#2DD4BF' : '#0D9488'
              }
            }}
            onClick={() => handlerDrawerOpen(!drawerOpen)}
          >
            <IconMenu2 stroke={1.5} size={22} />
          </ButtonBase>
        </Tooltip>
      </Box>

      {/* header search & filter */}
      <SearchSection />

      {/* spacer to push action controls to right */}
      <Box sx={{ flexGrow: 1 }} />

      {/* Right controls cluster with consistent 8px spacing */}
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>

        {/* Notification control */}
        <NotificationSection />

        {/* Profile Avatar control */}
        <ProfileSection />

        {/* Standalone Settings button */}
        <Tooltip title="Settings" arrow>
          <ButtonBase
            sx={{
              width: 38,
              height: 38,
              minWidth: 38,
              borderRadius: '8px',
              bgcolor: isSettingsActive 
                ? (mode === 'dark' ? 'rgba(20, 184, 166, 0.12)' : '#F0FDFA') 
                : 'transparent',
              color: isSettingsActive 
                ? (mode === 'dark' ? '#2DD4BF' : '#0D9488') 
                : (mode === 'dark' ? (theme.palette?.text?.secondary || '#A4ABB8') : '#475569'),
              transition: 'all 0.2s ease-in-out',
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              '&:hover': {
                bgcolor: mode === 'dark' ? (theme.palette?.background?.hover || '#2A2E36') : '#F1F5F9',
                color: mode === 'dark' ? '#2DD4BF' : '#0D9488'
              }
            }}
            onClick={() => navigate('/account-settings')}
          >
            <IconSettings stroke={1.5} size={22} />
          </ButtonBase>
        </Tooltip>
      </Box>
    </>
  );
}
